import { render } from "./CoinLogsEdit.vue?vue&type=template&id=6439d029"
import script from "./CoinLogsEdit.vue?vue&type=script&lang=js"
export * from "./CoinLogsEdit.vue?vue&type=script&lang=js"

import "./CoinLogsEdit.vue?vue&type=style&index=0&id=6439d029&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__